import { Separator } from '@/components/ui/separator';
import { PluginConfigData } from '@/types/plugin-config';
import { usePluginConfig, useTranslation } from '@tagadapay/plugin-sdk/v2';

export function BottomLinks() {
  const { config } = usePluginConfig<PluginConfigData>();
  const bottomLinks = config?.links?.bottomLinks;
  const { t } = useTranslation();

  if (!bottomLinks || bottomLinks.length === 0) {
    return null;
  }

  return (
    <>
      <Separator />
      <div className="mt-4 flex flex-wrap gap-2">
        {bottomLinks.map((link, index) => (
          <a
            className="text-sm underline"
            href={link.url}
            key={`${link.url}-${index}`}
            editor-id={`config.links.bottomLinks.${index}.url config.links.bottomLinks.${index}.label`}
          >
            {t(link.label)}
          </a>
        ))}
      </div>
    </>
  );
}
